export const serviceLevelMixin = {
  methods: {
    serviceLevel(agreement) {
      switch (agreement) {
        case 0:
          return {
            title: 'Basic',
            code: agreement,
          };
        case 1:
          return {
            title: 'Sourcing',
            code: agreement,
          };
        case 2:
          return {
            title: 'Full-service',
            code: agreement,
          };
        case 3:
          return {
            title: 'Nearshore',
            code: agreement,
          };
        case 4:
          return {
            title: 'Freelancers',
            code: agreement,
          };
        default:
          return { title: '', code: agreement };
      }
    },
  },
};
